export default __webpack_public_path__ + "static/media/img-7.f6859a84.jpg";